module.exports = function (targetObject) {
	console.warn("Error.captureStackTrace is undefined in this environment. It's been defined by client-logger instead.");

	// Potentially more options here, but they don't seem to do anything for us
	// https://github.com/babel/babel/commit/719d23eb3b94598a0ba41f339b52d54d2395b99f
	targetObject.stack = targetObject.stack || targetObject.name || 'Error';
};
